<template>
  <div class="container">
    <h1 class="h1" v-if="createByCustomerForm">Create Billing Profile for {{ this.customerBillingReference }}</h1>
    <h1 class="h1" v-else-if="createForm">Create Billing Profile</h1>
    <h1 class="h1" v-else>Edit Billing Profile</h1>
    <br/>
    <sdx-input-group type="radio" label="Choose Type" inline
                     oninput="console.log('Checked:', arguments[0].target.value)">
      <sdx-input-item @change="toggleCompany()" :checked=this.companyForm>Company</sdx-input-item>
      <sdx-input-item @change="togglePrivate()" :checked=!this.companyForm>Private</sdx-input-item>
    </sdx-input-group>
    <br/>
    <h5 class="h5">Address</h5>
    <hr class="divider divider--dark-gray margin-top-0 margin-bottom-1" aria-hidden="true">
    <div v-if="companyForm">
      <div class="row">
        <div class="col-md-4">
          <sdx-input
              id="companyLabel"
              label="Company Name"
              required="true"
              class="sdx-input"
              placeholder="e.g. Swisscom"
              :value="companyName"
              @input="companyName=$event.target.value;validateForm()"
          />
        </div>
      </div>
      <div class="row margin-top-1">
        <div class="col-md-4">
          <sdx-input
              id="zefix"
              label="Zefix UID"
              class="sdx-input"
              placeholder="CHE-102.753.938"
              :value="zefix"
              @input="zefix=$event.target.value;validateForm()"
          >
            <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
            <span slot="infotip">UID can be found on <a href="https://www.zefix.ch"
                                                        target="zefix">Zentraler Firmenindex</a></span>
          </sdx-input>
        </div>
      </div>
      <div class="row margin-top-1">
        <div class="col-md-4">
          <sdx-input
              id="department"
              label="Department"
              class="sdx-input"
              placeholder="e.g. IT"
              :value="department"
              @input="department=$event.target.value;validateForm()"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-4">
          <sdx-input
              id="firstName"
              label="First Name"
              required="true"
              class="sdx-input"
              placeholder="e.g. Max"
              :value="firstName"
              @input="firstName=$event.target.value;validateForm()"
          />
        </div>
        <div class="col-md-4">
          <sdx-input
              id="lastName"
              label="Last Name"
              required="true"
              class="sdx-input"
              placeholder="e.g. Mustermann"
              :value="lastName"
              @input="lastName=$event.target.value;validateForm()"
          />
        </div>
      </div>
      <div class="row margin-top-1">
        <div class="col-md-4">

          <sdx-input-mask
              type="ddmmyyyy"
              label="Birthday"
              required="true"
              class="sdx-input"
              placeholder="23.08.1987"
              :value="birthday"
              @input="birthday=$event.target.value;validateForm()"
          />
        </div>
      </div>
    </div>
    <div class="row margin-top-1">
      <div class="col-md-4">
        <sdx-input
            id="street"
            label="Street and House number"
            required="true"
            class="sdx-input"
            placeholder="e.g. Genfergasse 14"
            :value="street"
            @input="street=$event.target.value;validateForm()"
        />
      </div>
    </div>
    <div class="row margin-top-1">
      <div class="col-md-1">
        <sdx-input
            id="zip"
            label="Zip"
            required="true"
            class="sdx-input"
            placeholder="e.g. 3011"
            :value="zip"
            @input="zip=$event.target.value;validateForm()"
        />
      </div>
      <div class="col-md-3">
        <sdx-input
            id="city"
            label="City"
            required="true"
            class="sdx-input"
            placeholder="e.g. Bern"
            :value="city"
            @input="city=$event.target.value;validateForm()"
        />
      </div>
    </div>
    <div class="row margin-top-1">
      <div class="col-md-4">
        <sdx-select
            id="countryDropDown"
            label="Country"
            required="true"
            placeholder="Choose a Country..."
            @input="handleCountryChange($event)">
          <sdx-select-option
              v-for="country in countryList"
              :key="country[0]"
              :value="country[0]"
              :selected="isSelectedCountry(country[0])">
            {{ country[1] }}
          </sdx-select-option>
        </sdx-select>
      </div>
    </div>
    <br/>
    <h5 class="h5">Digital Billing</h5>
    <hr class="divider divider--dark-gray margin-top-0 margin-bottom-1" aria-hidden="true">
    <div class="row">
      <div class="col-md-4">
        <sdx-input
            id="receiverEmail"
            required="true"
            label="E-Mail"
            class="sdx-input"
            placeholder="e.g. max.mustermann@swisscom.com"
            :value="billEmail"
            @input="billEmail=$event.target.value;validateForm()"
            :validation-message="(billEmail!='' && !validateEmail(billEmail)) ? 'The email you entered is not valid email' : ''"
        />
      </div>
      <div class="col-md-4">
        <sdx-select
            id="languageDropDown"
            label="Language"
            required="true"
            placeholder="Choose a Language..."
            @input="handleLanguageChange($event)">
          >
          <sdx-select-option
              v-for="language in billLanguageList"
              :key="language[0]"
              :value="language[0]"
              :selected="isSelectedBillLanguage(language[0])"
          >
            {{ language[1] }}
          </sdx-select-option>
        </sdx-select>
      </div>
    </div>
    <br/>
    <h5 class="h5">Contact Person</h5>
    <hr class="divider divider--dark-gray margin-top-0 margin-bottom-1" aria-hidden="true">
    <div class="row">
      <div class="col-md-4">
        <sdx-input
            id="contactPersonFirstName"
            label="First Name"
            required="true"
            class="sdx-input"
            placeholder="e.g Lua"
            :value="contactPersonFirstName"
            @input="contactPersonFirstName=$event.target.value;validateForm()"
        />
      </div>
      <div class="col-md-4">
        <sdx-input
            id="contactPersonLastName"
            label="Last Name"
            required="true"
            class="sdx-input"
            placeholder="e.g Maurer"
            :value="contactPersonLastName"
            @input="contactPersonLastName=$event.target.value;validateForm()"
        />
      </div>
    </div>
    <div class="row margin-top-1">
      <div class="col-md-4">
        <sdx-input
            id="contactPersonEmail"
            label="E-Mail"
            required="true"
            class="sdx-input"
            placeholder="e.g. lua.maurer@example.com"
            :value="contactPersonEmail"
            @input="contactPersonEmail=$event.target.value;validateForm()"
            :validation-message="(contactPersonEmail!='' && !validateEmail(contactPersonEmail)) ? 'The email you entered is not valid email' : ''"
        />
      </div>
    </div>
    <div class="row margin-top-1">
      <div class="col-md-4">
        <sdx-input
            id="contactPerson"
            label="Phone Number"
            class="sdx-input"
            placeholder="+4179..."
            :value="contactPersonPhoneNumber"
            @input="contactPersonPhoneNumber=$event.target.value;validateForm()"
            :validation-message="(contactPersonPhoneNumber!='' && !validatePhoneNumber(contactPersonPhoneNumber)) ? 'The number you entered is not a valid phone number' : ''"
        />
      </div>
    </div>
    <br/>
    <div class="container admin-div" v-if="isAdmin">
      <span class="label sdx-light-theme admin-select-text">Admin Input</span>
      <hr class="margin-top-0 margin-bottom-1" aria-hidden="true">
      <div class="row">
        <div class="col-md-4">
          <span class="label sdx-light-theme admin-select-text">Customer Billing Reference *&nbsp;<sdx-menu-flyout>
        <sdx-menu-flyout-toggle>
          <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
        </sdx-menu-flyout-toggle>
        <sdx-menu-flyout-content style="width: 600px;">
          <p>Maximal 12 chars and must be unique (Error 500 can be a problem with the uniqueness)</p>
        </sdx-menu-flyout-content>
      </sdx-menu-flyout></span>
          <sdx-input
              id="customerBillingReference"
              class="sdx-input"
              placeholder=""
              maxlength="12"
              :value="customerBillingReference"
              @input="customerBillingReference=$event.target.value;validateForm()"
          />
        </div>
        <div class="col-md-4">
          <span class="label sdx-light-theme admin-select-text">Scn</span>
          <sdx-input
              id="scn"
              class="sdx-input"
              placeholder=""
              :value="scn"
              @input="scn=$event.target.value;validateForm()"
          />
        </div>
        <div class="col-md-4">
          <span class="label sdx-light-theme admin-select-text">Backend Contract ID</span>
          <sdx-input
              id="backendContractId"
              class="sdx-input"
              placeholder=""
              :value="backendContractId"
              @input="backendContractId=$event.target.value;validateForm()"
          />
        </div>
        <div class="col-md-12">
          <span class="label sdx-light-theme admin-select-text">Comment</span>
          <sdx-input
              id="comment"
              class="sdx-input"
              placeholder=""
              :value="comment"
              @input="comment=$event.target.value;validateForm()"
          />
        </div>
      </div>
      <br/>
      <span class="label sdx-light-theme admin-select-text">Price (Rappen)</span>
      <hr class="divider divider--light-gray margin-top-0 margin-bottom-1" aria-hidden="true">
      <div class="row">
        <div class="col-md-4">
          <span class="label sdx-light-theme admin-select-text">Swisscom *</span>
          <sdx-input
              id="priceSwisscom"
              class="sdx-input"
              :value="priceSwisscom"
              @input="priceSwisscom=$event.target.value;validateForm()"
          />
        </div>
        <div class="col-md-4">
          <span class="label sdx-light-theme admin-select-text">National *</span>
          <sdx-input
              id="priceNational"
              class="sdx-input"
              :value="priceNational"
              @input="priceNational=$event.target.value;validateForm()"
          />
        </div>
        <div class="col-md-4">
          <span class="label sdx-light-theme admin-select-text">International *</span>
          <sdx-input
              id="priceInterNational"
              class="sdx-input"
              :value="priceInterNational"
              @input="priceInterNational=$event.target.value;validateForm()"
          />
        </div>
      </div>

    </div>
    <br/>
    <div class="row flex-items-xs-between">
      <div class="col-xs-4">
        <div v-if="formIsValid">
          <sdx-dialog
              ref="modal-save"
              type="closable-modal"
              label="Would you like to save your Billing?">
            <sdx-dialog-toggle>
              <sdx-button
                  theme="secondary"
                  label="Overview"
                  class="sdx-button-child"
              />
            </sdx-dialog-toggle>
            <sdx-dialog-content>
              <sdx-button-group>
                <sdx-button
                    label="Save"
                    theme="secondary"
                    @click="saveProfileAndGoToOverview()"
                    :disabled="!formIsValid"
                />
                <sdx-button ref="buttonModalDiscard"
                            label="Discard"
                            @click="goToRoute('/billing/profiles')"
                            theme="secondary"></sdx-button>
              </sdx-button-group>
            </sdx-dialog-content>
          </sdx-dialog>
        </div>
        <div v-else>
          <sdx-button
              id="buttonOverview"
              ref="buttonOverview"
              label="Overview"
              @click="goToRoute('/billing/profiles')"
              theme="secondary">
          </sdx-button>
        </div>

      </div>
      <div class="col-xs-4 text-align-right">
        <sdx-button
            id="buttonSave"
            name="buttonSave"
            label="Save"
            class="sdx-button-object"
            @click="saveProfileAndGoToOverview()"
            :disabled="!formIsValid"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {logger} from "@/services/logger.service";
import billingService from '../service';
import {showAlert, showSuccess} from "@/services/notification.service";
import {validateEmail, validatePhoneNumber} from "@/util/utility";
import userService from "@/services/user.service";

export default {
  data() {
    return {
      formIsValid: false,
      isAdmin: false,
      customerBillingReference: '',
      scn: '',
      backendContractId: '',
      companyName: '',
      zefix: '',
      department: '',
      firstName: '',
      lastName: '',
      birthday: '',
      street: '',
      zip: '',
      city: '',
      countryList: [["CH", "Schweiz"], ["LI", "Liechtenstein"]],
      country: '',
      countryDefault: 'CH',
      billEmail: '',
      billLanguage: "",
      billLanguageList: [["DE", "Deutsch"], ["EN", "English"], ["FR", "Français"], ["IT", "Italiano"]],
      contactPersonFirstName: '',
      contactPersonLastName: '',
      contactPersonEmail: '',
      contactPersonPhoneNumber: '',
      priceSwisscom: '5',
      priceNational: '9',
      priceInterNational: '12',
      comment: '',
      profile: [],
      companyForm: true,
      createForm: false,
      createByCustomerForm: false,
      newBillingProfileEmail: '',
    }
  },
  async mounted() {
    this.isAdmin = await userService.isAdmin();
    this.createForm = this.$router.currentRoute.value.path === '/billing/profiles/create';
    this.createByCustomerForm = this.$router.currentRoute.value.path === '/billing/profiles/createbycustomer';
    await this.prepareData();
  },
  methods: {
    validateEmail,
    validatePhoneNumber,
    async prepareData() {
      if (this.createForm) {
        logger.debug("Form: Create new profile as admin");
        if (!this.isAdmin) {
          showAlert("Only admin can create new profiles!")
        }
      }
      if (this.createByCustomerForm) {
        this.newBillingProfileEmail = userService.getViewUserEmail();
        logger.debug("Form: Create new profile for customer " + this.newBillingProfileEmail);
        this.customerBillingReference = this.newBillingProfileEmail;
        this.billEmail = this.newBillingProfileEmail;
        this.contactPersonEmail = this.newBillingProfileEmail
      }
      if (!this.createForm && !this.createByCustomerForm) {
        logger.debug("Form: Update profile");
        await this.loadProfile();
        if (this.companyName === '') {
          this.companyForm = false;
        }
      }
    },
    async loadProfile() {
      try {
        this.profile = (await billingService.getBillingProfile(billingService.getBillingProfileIdFromSession())).data;
        logger.debug("BillingProfile: " + JSON.stringify(this.profile))
        this.customerBillingReference = this.profile.customerBillingReference;
        this.backendContractId = this.profile.backendContractId;
        this.scn = this.profile.scn;
        this.companyName = this.profile.company;
        this.zefix = this.profile.zefix;
        this.department = this.profile.department;
        this.firstName = this.profile.firstName;
        this.lastName = this.profile.lastName;
        this.birthday = this.profile.birthday;
        this.street = this.profile.street;
        this.zip = this.profile.zip;
        this.city = this.profile.city;
        this.country = this.profile.country;
        this.billEmail = this.profile.billEmail;
        this.billLanguage = this.profile.billLanguage;
        this.contactPersonFirstName = this.profile.contactPersonFirstName;
        this.contactPersonLastName = this.profile.contactPersonLastName;
        this.contactPersonEmail = this.profile.contactPersonEmail;
        this.contactPersonPhoneNumber = this.profile.contactPersonPhoneNumber;
        this.priceSwisscom = this.profile.priceSwisscom;
        this.priceNational = this.profile.priceNational;
        this.priceInterNational = this.profile.priceInternational;
        this.comment = this.profile.comment;
        logger.debug("customerBillingReference: " + this.customerBillingReference)
      } catch (error) {
        showAlert(error.message)
      }
    },
    goToRoute(route) {
      this.$router.push(route);
    },
    toggleCompany() {
      this.companyForm = true
      this.validateForm()
    },
    togglePrivate() {
      this.companyForm = false
      this.validateForm()
    },
    validateForm() {
      this.formIsValid =
          (!this.companyForm || this.companyName != '')
          && (this.companyForm || (this.firstName != '' && this.lastName != '' && this.birthday != ''))
          && this.street !== ''
          && this.zip !== ''
          && this.country !== ''
          && this.billEmail !== ''
          && validateEmail(this.billEmail)
          && this.billLanguage !== ''
          && this.contactPersonFirstName !== ''
          && this.contactPersonLastName !== ''
          && this.contactPersonEmail !== ''
          && validateEmail(this.contactPersonEmail)
          && (!this.isAdmin || (this.customerBillingReference !== '' && this.priceSwisscom !== '' && this.priceNational !== '' && this.priceInterNational !== ''));
    },
    getValueIfTrue(value, condition) {
      if (condition)
        return value;
      else
        return '';
    },
    async saveProfileAndGoToOverview() {

      if (this.createByCustomerForm) {
        try {
          await billingService.createBillingProfileByCustomer(
              this.newBillingProfileEmail,
              this.getValueIfTrue(this.companyName, this.companyForm),
              this.getValueIfTrue(this.zefix, this.companyForm),
              this.getValueIfTrue(this.firstName, !this.companyName),
              this.getValueIfTrue(this.lastName, !this.companyName),
              this.getValueIfTrue(this.birthday, !this.companyName),
              this.billEmail,
              this.department,
              this.street,
              this.zip,
              this.city,
              this.country.toString(),
              this.billLanguage.toString(),
              this.contactPersonFirstName,
              this.contactPersonLastName,
              this.contactPersonEmail,
              this.contactPersonPhoneNumber,
              this.comment);
          showSuccess('Billing Profile created successfully. We will contact you soon.')
          this.$router.push('/');
        } catch (exception) {
          showAlert("Could not create Billing Profile! Please contact api.team@swisscom.com")
        }
      }
      if (this.createForm) {
        try {
          await billingService.createBillingProfileByAdmin(
              this.customerBillingReference,
              this.scn,
              this.backendContractId,
              this.getValueIfTrue(this.companyName, this.companyForm),
              this.getValueIfTrue(this.zefix, this.companyForm),
              this.getValueIfTrue(this.firstName, !this.companyName),
              this.getValueIfTrue(this.lastName, !this.companyName),
              this.getValueIfTrue(this.birthday, !this.companyName),
              this.billEmail,
              this.department,
              this.street,
              this.zip,
              this.city,
              this.country.toString(),
              this.billLanguage.toString(),
              this.contactPersonFirstName,
              this.contactPersonLastName,
              this.contactPersonEmail,
              this.contactPersonPhoneNumber,
              this.priceSwisscom,
              this.priceNational,
              this.priceInterNational,
              this.comment);
          showSuccess('Billing Profile created successfully')
          this.$router.push('/billing/profiles');
        } catch (exception) {
          showAlert("Could not create Billing Profile!")
        }
      }
      if (!this.createForm && !this.createByCustomerForm) {
        try {
          await billingService.updateBillingProfile(
              billingService.getBillingProfileIdFromSession(),
              this.customerBillingReference,
              this.scn,
              this.backendContractId,
              this.getValueIfTrue(this.companyName, this.companyForm),
              this.getValueIfTrue(this.zefix, this.companyForm),
              this.getValueIfTrue(this.firstName, !this.companyName),
              this.getValueIfTrue(this.lastName, !this.companyName),
              this.getValueIfTrue(this.birthday, !this.companyName),
              this.billEmail,
              this.department,
              this.street,
              this.zip,
              this.city,
              this.country.toString(),
              this.billLanguage.toString(),
              this.contactPersonFirstName,
              this.contactPersonLastName,
              this.contactPersonEmail,
              this.contactPersonPhoneNumber,
              this.priceSwisscom,
              this.priceNational,
              this.priceInterNational,
              this.comment);
          showSuccess('Billing Profile saved successfully')
          this.$router.push('/billing/profiles/view/' + (this.isAdmin ? "admin" : "user"));
        } catch
            (exception) {
          showAlert("Could not save Billing Profile!")
        }
      }
    },
    handleLanguageChange(event) {
      this.billLanguage = event.target.value;
      this.validateForm();
    }
    ,
    handleCountryChange(event) {
      this.country = event.target.value;
      this.validateForm();
    }
    ,
    isSelectedBillLanguage(language) {
      let result = (language !== undefined && this.billLanguage !== undefined && this.billLanguage !== null && language.toLowerCase() === ("" + this.billLanguage).toLowerCase())
      return result;
    }
    ,
    isSelectedCountry(country) {
      let result = (country !== undefined && this.country !== undefined && this.country !== null && country.toLowerCase() === ("" + this.country).toLowerCase())
      return result;
    }
  }
}
</script>

<style>
.admin-div {
  font-weight: bold;
  background-color: #862351;
  border-radius: 10px;
  margin-top: 10px;
  padding-top: 1px !important;
  padding-bottom: 6px !important;
}
</style>